import { entities, formatters } from "@fraction/shared";
import Avatar from "src/components/Avatar";
import Skeleton from "src/components/Skeleton";
import { Button } from "src/components/ui/button";
import { useClipboard } from "src/hooks/useClipboard";
import { cn } from "src/utilities/shadcnUtils";
import { Badge } from "./ui/badge";

export default function EmployeeCard({
  contact,
  loading,
  className,
  title,
  type,
  buttonClassName,
}: {
  contact?: Partial<entities.InternalEmployee>;
  loading?: boolean;
  className?: string;
  type?: string;
  title?: string;
  buttonClassName?: string;
}) {
  const onClick = useClipboard();
  if (loading) {
    return <Skeleton height={122} width="100%" />;
  }
  if (!contact) {
    return null;
  }
  return (
    <div className={cn("gap-y-2 w-fit flex-col flex", className)}>
      <div className="flex flex-row gap-x-4 items-center">
        <Avatar
          className="rounded-full border border-black h-[50px] w-[50px] min-h-[50px] min-w-[50px]"
          src={contact.photoLink}
        >
          {formatters.user.userName(contact.user)}
        </Avatar>
        <div className="w-full">
          <div className="flex flex-row items-center justify-between gap-x-4 gap-y-1 w-full flex-wrap">
            <p className="text-md leading-4 font-bold font-serif-deck">
              {title ? title : `${contact.user?.firstName} ${contact.user?.lastName}`}
            </p>
            {type ? (
              <Badge variant="lightgreen" className="rounded-full">
                {type}
              </Badge>
            ) : null}
          </div>
          <div>
            <p>
              <button onClick={onClick} className="text-sm hover:font-semibold font-medium">
                {contact.user?.email}
              </button>
            </p>
            <p>
              <button onClick={onClick} className="text-sm hover:font-semibold font-medium">
                {formatters.phone.formatPhoneNumber(contact.user?.phone)}
              </button>
            </p>
          </div>
        </div>
      </div>
      {contact.calendarLink ? (
        <a target="_blank" href={contact.calendarLink}>
          <Button className={cn("mt-2 self-start", buttonClassName)} variant="green">
            Book a call with {contact.user?.firstName}
          </Button>
        </a>
      ) : null}
    </div>
  );
}
